import type { DashboardSummaryDto } from '@signalvote/shared';
import { apiJson } from './apiFetch';
import { financeReadKeys } from '../../lib/queryKeys';
import { campaignHeaders, defineQuery } from '../../lib/data';

export type { DashboardSummaryDto };

/**
 * Windowed flow totals for the dashboard hero (ADR-017). The window resolves from the period
 * switcher against `health`, so the caller passes `whenReady(window)`: the summary waits while
 * the window waits and fails when it fails, rather than fetching a fallback window.
 */
export const useDashboardSummary = defineQuery({
  key: financeReadKeys.dashboardSummary,
  reads: 'GET /api/finance/dashboard/summary',
  fetch: ({ from, to }: { from: string; to: string }, { signal, campaignId }) =>
    apiJson<DashboardSummaryDto>(`/api/finance/dashboard/summary?from=${from}&to=${to}`, {
      signal,
      headers: campaignHeaders(campaignId),
      error: 'Failed to fetch dashboard summary',
    }),
  staleTime: 30_000,
});
